'use client'
import type { LoyaltyVoucherListProps } from '@maestro/commerce-blocks/loyalty/components/loyalty-voucher-list/loyalty-voucher-list.types'

import classNames from 'classnames'
import { useTranslations } from 'next-intl'
import { useMemo } from 'react'

import { TrackingTextClamp } from '@maestro/commerce-blocks/components/tracking-text-clamp'
import { LoyaltyVoucherCard } from '@maestro/commerce-blocks/loyalty/components/loyalty-voucher-card'
import { useLoyaltyVoucherList } from '@maestro/commerce-blocks/loyalty/components/loyalty-voucher-list/batons/use-loyalty-voucher-list'

export default function LoyaltyVoucherList(props: LoyaltyVoucherListProps) {
  const { isSelectionEnabled, title, description, className } = props
  const { isLoading, vouchers, handleChange } = useLoyaltyVoucherList(props)

  const t = useTranslations('commerce-blocks.loyalty.voucher-list')

  const expandButton = useMemo(
    () => (
      <div className="section-header">
        <div className="loyalty-voucher-list__show-more">
          <span className="loyalty-voucher-list__show-more-text">
            {t('show-more')}
          </span>{' '}
          <span className="loyalty-voucher-list__show-more-count">
            {vouchers.length}
          </span>
        </div>
      </div>
    ),
    [t, vouchers.length]
  )

  return (
    <div className={classNames('loyalty-voucher-list', className)}>
      <h2 className="section-title loyalty-voucher-list__title">{title}</h2>
      <p className="loyalty-voucher-list__description">{description}</p>
      <TrackingTextClamp location="loyalty-voucher-list" expandText={expandButton}>
        <ul className="loyalty-voucher-list__items">
          {vouchers.map((voucher) => (
            <li
              key={`loyalty-voucher-list-item-${voucher.id}`}
              className="loyalty-voucher-list__item"
            >
              <LoyaltyVoucherCard
                voucher={voucher}
                isSelectionEnabled={isSelectionEnabled}
                isDisabled={isLoading}
                isSelected={voucher.isSelected}
                onSelectVoucher={handleChange}
              />
            </li>
          ))}
        </ul>
      </TrackingTextClamp>
    </div>
  )
}
